/** loadable loading comp*/

import React from 'react';
import {ActivityIndicator} from 'antd-mobile-v2';

const LoadingComponent = () => {
  return <ActivityIndicator toast text="加载中..." />;
};

export default LoadingComponent;
